import ApiService from './ApiService'

export async function apiSubPackages() {
    return ApiService.fetchData({
        url: '/billing/packages',
        method: 'get',
    })
}

export async function apiSetupCreditSubscription(data) {
    return ApiService.fetchData({
        url: '/billing/checkout/setup-credit-subscription',
        method: 'post',
        data,
    })
}
export async function apiCreateWireSubscription(data) {
    return ApiService.fetchData({
        url: '/billing/checkout/create-wire-subscription',
        method: 'post',
        data,
    })
}
export async function apiVerifyTransaction(data) {
    return ApiService.fetchData({
        url: '/billing/checkout/verify-transaction-credit',
        method: 'post',
        data,
    })
}
export async function apiVerifyTransactionWireTransfer(data) {
    return ApiService.fetchData({
        url: '/billing/checkout/verify-transaction-wire',
        method: 'post',
        data,
    })
}

export async function apiUserActiveSubscription() {
    return ApiService.fetchData({
        url: '/billing/user-active-subscription',
        method: 'get',
    })
}
export async function apiUserInvoices() {
    return ApiService.fetchData({
        url: '/billing/user-invoices',
        method: 'get',
    })
}
export async function apiCancelSubscription() {
    return ApiService.fetchData({
        url: '/billing/cancel-subscription',
        method: 'post',
    })
}
export async function apiDowngradeSubscription(data) {
    return ApiService.fetchData({
        url: '/billing/downgrade-subscription',
        method: 'post',
        data,
    })
}

export async function apiFetchBillingAddressDetails() {
    return ApiService.fetchData({
        url: '/billing/fetch-billing-address-details',
        method: 'get',
    })
}
export async function apiUpdateBillingAddressDetails(data) {
    return ApiService.fetchData({
        url: '/billing/update-billing-address-details',
        method: 'post',
        data,
    })
}

export async function apiInitManagePaymentMethods() {
    return ApiService.fetchData({
        url: '/billing/manage-payment-methods/init',
        method: 'post',
    })
}

export async function removeCreditCard(data) {
    return ApiService.fetchData({
        url: '/billing/manage-payment-methods/remove-credit-card',
        method: 'post',
        data,
    })
}
export async function apiUpdateDefaultCard(data) {
    return ApiService.fetchData({
        url: '/billing/manage-payment-methods/update-default-card',
        method: 'post',
        data,
    })
}
export async function apiFetchTechnicalAddressDetails() {
    return ApiService.fetchData({
        url: '/billing/fetch-technical-address-details',
        method: 'get',
    })
}
export async function apiUpdateTechnicalAddressDetails(data) {
    return ApiService.fetchData({
        url: '/billing/update-technical-address-details',
        method: 'post',
        data,
    })
}
export async function apiUserNotifications() {
    return ApiService.fetchData({
        url: '/billing/user-notifications',
        method: 'get',
    })
}
